import { FC, ReactNode } from 'react'
import { StyleButton, StyleButtonWrapper } from './style'
import theme from '@utils/theme'
import { StyleSvgWrappeer } from '@pages/front/commons/SvgIcon/style'
interface ButtonProps {
  type?: 'button' | 'submit' | 'reset'
  title?: string
  width?: number
  height?: number
  bg?: keyof typeof theme.colors
  tc?: keyof typeof theme.colors
  radius?: number
  styleButton?: string
  leftComponent?: ReactNode
  rightComponent?: ReactNode
  loading?: boolean
  disabled?: boolean
  outline?: boolean
  onClick?: (event?: any) => void
  children?: ReactNode
  styleButtonWrapper?: string
  icon?: string
}
const Button: FC<ButtonProps> = ({
  type = 'button',
  title,
  loading,
  disabled = false,
  leftComponent,
  rightComponent,
  children,
  styleButtonWrapper = '',
  outline = false,
  icon,

  ...restProps
}) => {
  return (
    <StyleButtonWrapper styleButtonWrapper={styleButtonWrapper}>
      <StyleButton
        outline={outline}
        disabled={!!loading ? loading : disabled}
        type={type}
        {...restProps}
      >
        {icon && (
          <StyleSvgWrappeer
            dangerouslySetInnerHTML={{ __html: icon }}
            translateY="2px"
          />
        )}
        {leftComponent && leftComponent}
        {!!loading ? 'Loading...' : title || children}
        {rightComponent && rightComponent}
      </StyleButton>
    </StyleButtonWrapper>
  )
}

export default Button
